module.exports = __webpack_public_path__ + "static/media/ico_tint_light.8b17aad1.svg";